import { useEffect } from 'react';

const STAGGER_MS = 70;
const INITIAL_DELAY_MS = 100;

function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export default function useRevealOnMount(containerRef, deps = []) {
  useEffect(() => {
    const root = containerRef.current;
    if (!root) return undefined;

    const targets = root.querySelectorAll('.reveal-item');
    if (!targets.length) return undefined;

    if (prefersReducedMotion()) {
      targets.forEach((el) => el.classList.add('reveal-item-visible'));
      return undefined;
    }

    targets.forEach((el) => {
      el.classList.remove('reveal-item-visible');
    });

    const frameId = requestAnimationFrame(() => {
      targets.forEach((el, i) => {
        el.style.setProperty('--reveal-delay', `${INITIAL_DELAY_MS + i * STAGGER_MS}ms`);
        el.classList.add('reveal-item-visible');
      });
    });

    return () => cancelAnimationFrame(frameId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
